<!--<div class="pagebrk"></div>
  <printheaderview>
  </printheaderview>-->
<div class="row">
  <div class="col-print-12 padding-left-0px">
    <div class="card">
      <div class="card-header padding-left-0px border-bottom-0 padding-top-0px padding-bottom-0px"></div>
      <div class="card-body padding-top-0px padding-bottom-0px font-weight-normal">

        <div class="row">
          <div class="col-print-12 text-align-center">
            <label class="font-familyhead">Oocyte Quality Assesment</label>
            <qrcode class="padding-top-0px padding-bottom-0px qr-style4" [qrdata]="PatientId" [size]="90" [level]="'M'"></qrcode>
          </div>
        </div>

        <div class="col-print-12 bordertop border-bot-1px border-bottom-1px">
          <div class="row margin-left-0px margin-right-0px">
            <div class="col-print-5 margin-top-10 margin-bottom-10px">
              <div class="row margin-left-0px margin-right-0px">
                <div class="col-print-6">
                  <label class="margin-bottom-0px font-family font-weight-normal">Patient:</label>
                </div>
                <div class="col-print-6">
                  <label class="margin-bottom-0px font-family float-left font-weight-bold">{{Owner}}</label>
                </div>
              </div>
              <div class="row margin-left-0px margin-right-0px">
                <div class="col-print-6">
                  <label class="margin-bottom-0px font-family font-weight-normal">Gender/Age:</label>
                </div>
                <div class="col-print-6">
                  <label class="margin-bottom-0px font-family float-left font-weight-normal">{{Gender}}/{{Age}}</label>
                </div>
              </div>
              <div class="row margin-left-0px margin-right-0px">
                <div class="col-print-6">
                  <label class="margin-bottom-0px font-family font-weight-normal">Patient ID:</label>
                </div>
                <div class="col-print-6">
                  <label class="margin-bottom-0px font-family float-left font-weight-normal">{{PatientId}}</label>
                </div>
              </div>
              <div class="row margin-left-0px margin-right-0px">
                <div class="col-print-6">
                  <label class="margin-bottom-0px font-family font-weight-normal">Infertility Type:</label>
                </div>
                <div class="col-print-6">
                  <label class="margin-bottom-0px font-family float-left font-weight-normal">{{Infertility}}</label>
                </div>
              </div>
            </div>

            <div class="col-print-1"></div>

            <div class="col-print-5 margin-top-10 margin-bottom-10px">
              <div class="row margin-left-0px margin-right-0px">
                <div class="col-print-6">
                  <label class="margin-bottom-0px font-family font-weight-normal">Cycle:</label>
                </div>
                <div class="col-print-6">
                  <label class="margin-bottom-0px font-family float-left font-weight-normal">{{CycleType}} ({{CycleNo}})</label>
                </div>
              </div>
              <div class="row margin-left-0px margin-right-0px">
                <div class="col-print-6">
                  <label class="margin-bottom-0px font-family font-weight-normal">Protocol:</label>
                </div>
                <div class="col-print-6">
                  <label class="margin-bottom-0px font-family float-left font-weight-normal">{{Protocol}}</label>
                </div>
              </div>
              <div class="row margin-left-0px margin-right-0px">
                <div class="col-print-6">
                  <label class="margin-bottom-0px font-family font-weight-normal">Protocol Start:</label>
                </div>
                <div class="col-print-6">
                  <label class="margin-bottom-0px font-family float-left font-weight-normal">{{ProtocolStart | date:'dd-MMM-yyyy'}}</label>
                </div>
              </div>
              <div class="row margin-left-0px margin-right-0px">
                <div class="col-print-6">
                  <label class="margin-bottom-0px font-family font-weight-normal">Protocol End:</label>
                </div>
                <div class="col-print-6">
                  <label class="margin-bottom-0px font-family float-left font-weight-normal">{{ProtocolEnd | date:'dd-MMM-yyyy'}}</label>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-print-12">
          <div class="row margin-left-0px margin-right-0px">
            <div class="col-print-2">
              <label class="margin-bottom-0px font-family font-weight-normal"></label>
            </div>
            <div class="col-print-6">
              <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
            </div>
          </div>
        </div>
        <div class="col-print-12">
          <div class="row margin-left-0px margin-right-0px">
            <div class="col-print-6">
              <label class="margin-bottom-0px font-family font-weight-bold">OQA</label>
            </div>
            <div class="col-print-6">
              <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
            </div>
          </div>
        </div>
        <div class="col-print-11">
          <div class="row margin-right-0px margin-left-0px">
            <div class="col-print-11">
              <div class="table-component margin-bottom-0px border4">
                <div class="table-responsive">
                  <table class="table table-striped margin-left-zero">
                    <thead>
                      <tr>
                        <th class="font-weight-normal background-primary padding-top-2px padding-bottom-2px font-family width-35px text-align-center">
                          S.No
                        </th>

                        <th class="font-weight-normal background-primary padding-top-2px padding-bottom-2px font-family width-35px text-align-center">
                          Well#
                        </th>

                        <th class="font-weight-normal background-primary text-align-center padding-top-2px padding-bottom-2px font-family width-150px">
                          OCC
                        </th>
                        <th class="font-weight-normal background-primary text-align-center padding-top-2px padding-bottom-2px font-family width-150px">
                          Denuded
                        </th>
                        <th class="font-weight-normal background-primary text-align-center padding-top-2px padding-bottom-2px font-family">
                          Morphology
                        </th>
                        <th class="font-weight-normal background-primary text-align-center padding-top-2px padding-bottom-2px font-family">
                          Status
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let l of CurrentOocyteQualityAssessmentByCodeController ; let RowIndex = index ">
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-center">{{RowIndex+1}}</td>
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-center">{{l.WellNo}}</td>
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-center">{{l.OocyteQualityPre}}</td>
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-center">{{l.OocyteQualityPost}}</td>
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-center">{{l.Morphology}}</td>
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-center">{{l.RecordStatus}}</td>
                      </tr>
                    </tbody>
                  </table>

                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-print-12">
          <div class="row margin-left-0px">
            <div class="col-print-2">
              <label class="margin-bottom-0px font-family font-weight-normal"></label>
            </div>
            <div class="col-print-6">
              <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
            </div>
          </div>
        </div>
        <div class="col-print-12">
          <div class="row margin-left-0px margin-right-0px">
            <div class="col-print-2">
              <label class="margin-bottom-0px font-family font-weight-bold">Oocyte Storage</label>
            </div>
            <div class="col-print-6">
              <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
            </div>
          </div>
        </div>

        <div class="col-print-11">
          <div class="row margin-left-0px margin-right-0px">
            <div class="col-print-11">
              <div class="table-component margin-bottom-0px border4">
                <div class="table-responsive">
                  <table class="table table-striped margin-left-zero">
                    <thead>
                      <tr>

                        <th class="font-weight-normal background-primary padding-top-2px padding-bottom-2px font-family width-35px text-align-center">
                          Well#
                        </th>

                        <th class="font-weight-normal background-primary text-align-center padding-top-2px padding-bottom-2px font-family">
                          Morphology
                        </th>
                        <th class="font-weight-normal background-primary text-align-center padding-top-2px padding-bottom-2px font-family">
                          Storage
                        </th>
                        <th class="font-weight-normal background-primary text-align-center padding-top-2px padding-bottom-2px font-family">
                          Details
                        </th>
                        <th class="font-weight-normal background-primary text-align-center padding-top-2px padding-bottom-2px font-family">
                          Status
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let l of CurrentIvfOocyteEmbryoStorageByCodeController">
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-center">{{l.WellNo}}</td>
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-center">{{l.Morphology}}</td>
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-center">{{l.StorageUnitType}}</td>
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-center">{{l.StorageUnitDetails}}</td>
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-center">{{l.Status}}</td><!--{{l.RecordStatus}}-->
                      </tr>
                    </tbody>
                  </table>

                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-print-12">
          <div class="row margin-left-0px">
            <div class="col-print-6">
              <label class="margin-bottom-0px font-family font-weight-normal"></label>
            </div>
            <div class="col-print-6">
              <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
            </div>
          </div>
        </div>
        <div class="col-print-12">
          <div class="row margin-left-0px">
            <div class="col-print-6">
              <label class="margin-bottom-0px font-family font-weight-normal"></label>
            </div>
            <div class="col-print-6">
              <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
            </div>
          </div>
        </div>
        <div class="col-print-12">
          <div class="row margin-left-0px margin-right-0px">
            <div class="col-print-4">
              <div class="row margin-left-0px">
                <div class="col-print-5">
                  <label class="margin-bottom-0px font-family font-weight-normal">Total Oocytes:</label>
                </div>
                <div class="col-print-1 border-bot-1px">
                  <label class="margin-bottom-0px font-family text-align-center font-weight-bold">{{TotalCount}}</label>
                </div>
              </div>
            </div>
            <div class="col-print-4">
              <div class="row margin-left-0px">
                <div class="col-print-6">
                  <label class="margin-bottom-0px font-family font-weight-normal">Frozen Oocytes:</label>
                </div>
                <div class="col-print-1 border-bot-1px">
                  <label class="margin-bottom-0px font-family text-align-center font-weight-bold">{{FrozenCount}}</label>
                </div>
              </div>
            </div>
            <div class="col-print-4">
              <div class="row margin-left-0px">
                <div class="col-print-7">
                  <label class="margin-bottom-0px font-family font-weight-normal">Discarded Oocytes:</label>
                </div>
                <div class="col-print-1 border-bot-1px">
                  <label class="margin-bottom-0px font-family text-align-center font-weight-bold">{{DiscardedCount}}</label>
                </div>
              </div>
            </div>
            <!--<div class="col-print-3">
              <label class="margin-bottom-0px font-family font-weight-normal">Frozen Oocytes:</label>
            </div>
            <div class="col-print-1 border-bot-1px">
              <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
            </div>
            <div class="col-print-3">
              <label class="margin-bottom-0px font-family font-weight-normal">Discarded Oocytes:</label>
            </div>
            <div class="col-print-1 border-bot-1px">
              <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
            </div>-->
          </div>
        </div>
        <div class="col-print-12">
          <div class="row margin-left-0px">
            <div class="col-print-6">
              <label class="margin-bottom-0px font-family font-weight-normal"></label>
            </div>
            <div class="col-print-6">
              <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
            </div>
          </div>
        </div>
        <div class="col-print-12">
          <div class="row margin-left-0px margin-right-0px">
            <div class="col-print-6">
              <label class="margin-bottom-0px font-family font-weight-bold">Oocyte Count By Morphology</label>
            </div>
            <div class="col-print-6">
              <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
            </div>
          </div>
        </div>
        <div class="col-print-12">
          <div class="row margin-left-0px margin-right-0px">
            <div class="col-print-3" *ngIf="AggregatedCount > 0">
              <div class="row margin-left-0px">
                <div class="col-print-9">
                  <label class="margin-bottom-0px font-family font-weight-normal">Aggregated:</label>
                </div>
                <div class="col-print-1 border-bot-1px">
                  <label class="margin-bottom-0px font-family text-align-center font-weight-bold">{{AggregatedCount}}</label>
                </div>
              </div>
            </div>
            <div class="col-print-3" *ngIf="AZPCount > 0">
              <div class="row margin-left-0px">
                <div class="col-print-9">
                  <label class="margin-bottom-0px font-family font-weight-normal">AZP:</label>
                </div>
                <div class="col-print-1 border-bot-1px">
                  <label class="margin-bottom-0px font-family text-align-center font-weight-bold">{{AZPCount}}</label>
                </div>
              </div>
            </div>
            <div class="col-print-3" *ngIf="CGMCount > 0">
              <div class="row margin-left-0px">
                <div class="col-print-9">
                  <label class="margin-bottom-0px font-family font-weight-normal">CGM:</label>
                </div>
                <div class="col-print-1 border-bot-1px">
                  <label class="margin-bottom-0px font-family text-align-center font-weight-bold">{{CGMCount}}</label>
                </div>
              </div>
            </div>
            <div class="col-print-3" *ngIf="EGMCount > 0">
              <div class="row margin-left-0px">
                <div class="col-print-9">
                  <label class="margin-bottom-0px font-family font-weight-normal">EGM:</label>
                </div>
                <div class="col-print-1 border-bot-1px">
                  <label class="margin-bottom-0px font-family text-align-center font-weight-bold">{{EGMCount}}</label>
                </div>
              </div>
            </div>
            <div class="col-print-3" *ngIf="FPBCount > 0">
              <div class="row margin-left-0px">
                <div class="col-print-9">
                  <label class="margin-bottom-0px font-family font-weight-normal">FPB:</label>
                </div>
                <div class="col-print-1 border-bot-1px">
                  <label class="margin-bottom-0px font-family text-align-center font-weight-bold">{{FPBCount}}</label>
                </div>
              </div>
            </div>
            <div class="col-print-3" *ngIf="FragileCount > 0">
              <div class="row margin-left-0px">
                <div class="col-print-9">
                  <label class="margin-bottom-0px font-family font-weight-normal">Fragile Oolemma:</label>
                </div>
                <div class="col-print-1 border-bot-1px">
                  <label class="margin-bottom-0px font-family text-align-center font-weight-bold">{{FragileCount}}</label>
                </div>
              </div>
            </div>
            <div class="col-print-3" *ngIf="GaintCount > 0">
              <div class="row margin-left-0px">
                <div class="col-print-9">
                  <label class="margin-bottom-0px font-family font-weight-normal">Gaint Oocyte:</label>
                </div>
                <div class="col-print-1 border-bot-1px">
                  <label class="margin-bottom-0px font-family text-align-center font-weight-bold">{{GaintCount}}</label>
                </div>
              </div>
            </div>
            <div class="col-print-3" *ngIf="OthersCount > 0">
              <div class="row margin-left-0px">
                <div class="col-print-9">
                  <label class="margin-bottom-0px font-family font-weight-normal">Others:</label>
                </div>
                <div class="col-print-1 border-bot-1px">
                  <label class="margin-bottom-0px font-family text-align-center font-weight-bold">{{OthersCount}}</label>
                </div>
              </div>
            </div>
            <div class="col-print-3" *ngIf="PVSCount > 0">
              <div class="row margin-left-0px">
                <div class="col-print-9">
                  <label class="margin-bottom-0px font-family font-weight-normal">PVS:</label>
                </div>
                <div class="col-print-1 border-bot-1px">
                  <label class="margin-bottom-0px font-family text-align-center font-weight-bold">{{PVSCount}}</label>
                </div>
              </div>
            </div>
            <div class="col-print-3" *ngIf="RefractileCount > 0">
              <div class="row margin-left-0px">
                <div class="col-print-9">
                  <label class="margin-bottom-0px font-family font-weight-normal">Refractile Body:</label>
                </div>
                <div class="col-print-1 border-bot-1px">
                  <label class="margin-bottom-0px font-family text-align-center font-weight-bold">{{RefractileCount}}</label>
                </div>
              </div>
            </div>
            <div class="col-print-3" *ngIf="SERCount > 0">
              <div class="row margin-left-0px">
                <div class="col-print-9">
                  <label class="margin-bottom-0px font-family font-weight-normal">SER:</label>
                </div>
                <div class="col-print-1 border-bot-1px">
                  <label class="margin-bottom-0px font-family text-align-center font-weight-bold">{{SERCount}}</label>
                </div>
              </div>
            </div>
            <div class="col-print-3" *ngIf="DLZCount > 0">
              <div class="row margin-left-0px">
                <div class="col-print-9">
                  <label class="margin-bottom-0px font-family font-weight-normal">DLZ:</label>
                </div>
                <div class="col-print-1 border-bot-1px">
                  <label class="margin-bottom-0px font-family text-align-center font-weight-bold">{{DLZCount}}</label>
                </div>
              </div>
            </div>
            <!--<div class="col-print-3">
              <label class="margin-bottom-0px font-family font-weight-normal">Frozen Oocytes:</label>
            </div>
            <div class="col-print-1 border-bot-1px">
              <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
            </div>
            <div class="col-print-3">
              <label class="margin-bottom-0px font-family font-weight-normal">Discarded Oocytes:</label>
            </div>
            <div class="col-print-1 border-bot-1px">
              <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
            </div>-->
            <div class="col-print-3" *ngIf="DPBCount > 0">
              <div class="row margin-left-0px">
                <div class="col-print-9">
                  <label class="margin-bottom-0px font-family font-weight-normal">DPB:</label>
                </div>
                <div class="col-print-1 border-bot-1px">
                  <label class="margin-bottom-0px font-family text-align-center font-weight-bold">{{DPBCount}}</label>
                </div>
              </div>
            </div>
            <div class="col-print-3" *ngIf="DPVSCount > 0">
              <div class="row margin-left-0px">
                <div class="col-print-9">
                  <label class="margin-bottom-0px font-family font-weight-normal">DPVS:</label>
                </div>
                <div class="col-print-1 border-bot-1px">
                  <label class="margin-bottom-0px font-family text-align-center font-weight-bold">{{DPVSCount}}</label>
                </div>
              </div>
            </div>
            <div class="col-print-3" *ngIf="DRKCCount > 0">
              <div class="row margin-left-0px">
                <div class="col-print-9">
                  <label class="margin-bottom-0px font-family font-weight-normal">DRKC:</label>
                </div>
                <div class="col-print-1 border-bot-1px">
                  <label class="margin-bottom-0px font-family text-align-center font-weight-bold">{{DRKCCount}}</label>
                </div>
              </div>
            </div>
            <div class="col-print-3" *ngIf="GPBCount > 0">
              <div class="row margin-left-0px">
                <div class="col-print-9">
                  <label class="margin-bottom-0px font-family font-weight-normal">GPB:</label>
                </div>
                <div class="col-print-1 border-bot-1px">
                  <label class="margin-bottom-0px font-family text-align-center font-weight-bold">{{GPBCount}}</label>
                </div>
              </div>
            </div>
            <div class="col-print-3" *ngIf="GRNLCCount > 0">
              <div class="row margin-left-0px">
                <div class="col-print-9">
                  <label class="margin-bottom-0px font-family font-weight-normal">GRNLC:</label>
                </div>
                <div class="col-print-1 border-bot-1px">
                  <label class="margin-bottom-0px font-family text-align-center font-weight-bold">{{GRNLCCount}}</label>
                </div>
              </div>
            </div>
            <div class="col-print-3" *ngIf="INCLBCount > 0">
              <div class="row margin-left-0px">
                <div class="col-print-9">
                  <label class="margin-bottom-0px font-family font-weight-normal">INCLB:</label>
                </div>
                <div class="col-print-1 border-bot-1px">
                  <label class="margin-bottom-0px font-family text-align-center font-weight-bold">{{INCLBCount}}</label>
                </div>
              </div>
            </div>
            <div class="col-print-3" *ngIf="LPVSCount > 0">
              <div class="row margin-left-0px">
                <div class="col-print-9">
                  <label class="margin-bottom-0px font-family font-weight-normal">LPVS:</label>
                </div>
                <div class="col-print-1 border-bot-1px">
                  <label class="margin-bottom-0px font-family text-align-center font-weight-bold">{{LPVSCount}}</label>
                </div>
              </div>
            </div>
            <div class="col-print-3" *ngIf="MCVCount > 0">
              <div class="row margin-left-0px">
                <div class="col-print-9">
                  <label class="margin-bottom-0px font-family font-weight-normal">MCV:</label>
                </div>
                <div class="col-print-1 border-bot-1px">
                  <label class="margin-bottom-0px font-family text-align-center font-weight-bold">{{MCVCount}}</label>
                </div>
              </div>
            </div>
            <div class="col-print-3" *ngIf="MICVCount > 0">
              <div class="row margin-left-0px">
                <div class="col-print-9">
                  <label class="margin-bottom-0px font-family font-weight-normal">MICV:</label>
                </div>
                <div class="col-print-1 border-bot-1px">
                  <label class="margin-bottom-0px font-family text-align-center font-weight-bold">{{MICVCount}}</label>
                </div>
              </div>
            </div>
            <div class="col-print-3" *ngIf="MPBCount > 0">
              <div class="row margin-left-0px">
                <div class="col-print-9">
                  <label class="margin-bottom-0px font-family font-weight-normal">MPB:</label>
                </div>
                <div class="col-print-1 border-bot-1px">
                  <label class="margin-bottom-0px font-family text-align-center font-weight-bold">{{MPBCount}}</label>
                </div>
              </div>
            </div>
            <div class="col-print-3" *ngIf="PCTPCount > 0">
              <div class="row margin-left-0px">
                <div class="col-print-9">
                  <label class="margin-bottom-0px font-family font-weight-normal">PCTP:</label>
                </div>
                <div class="col-print-1 border-bot-1px">
                  <label class="margin-bottom-0px font-family text-align-center font-weight-bold">{{PCTPCount}}</label>
                </div>
              </div>
            </div>
            <div class="col-print-3" *ngIf="SGCCount > 0">
              <div class="row margin-left-0px">
                <div class="col-print-9">
                  <label class="margin-bottom-0px font-family font-weight-normal">SGC:</label>
                </div>
                <div class="col-print-1 border-bot-1px">
                  <label class="margin-bottom-0px font-family text-align-center font-weight-bold">{{SGCCount}}</label>
                </div>
              </div>
            </div>
            <div class="col-print-3" *ngIf="SPBCount > 0">
              <div class="row margin-left-0px">
                <div class="col-print-9">
                  <label class="margin-bottom-0px font-family font-weight-normal">SPB:</label>
                </div>
                <div class="col-print-1 border-bot-1px">
                  <label class="margin-bottom-0px font-family text-align-center font-weight-bold">{{SPBCount}}</label>
                </div>
              </div>
            </div>
            <div class="col-print-3" *ngIf="SPTZCount > 0">
              <div class="row margin-left-0px">
                <div class="col-print-9">
                  <label class="margin-bottom-0px font-family font-weight-normal">SPTZ:</label>
                </div>
                <div class="col-print-1 border-bot-1px">
                  <label class="margin-bottom-0px font-family text-align-center font-weight-bold">{{SPTZCount}}</label>
                </div>
              </div>
            </div>
            <div class="col-print-3" *ngIf="STCOLCount > 0">
              <div class="row margin-left-0px">
                <div class="col-print-9">
                  <label class="margin-bottom-0px font-family font-weight-normal">STCOL:</label>
                </div>
                <div class="col-print-1 border-bot-1px">
                  <label class="margin-bottom-0px font-family text-align-center font-weight-bold">{{STCOLCount}}</label>
                </div>
              </div>
            </div>
            <div class="col-print-3" *ngIf="THCKZCount > 0">
              <div class="row margin-left-0px">
                <div class="col-print-9">
                  <label class="margin-bottom-0px font-family font-weight-normal">THCKZ:</label>
                </div>
                <div class="col-print-1 border-bot-1px">
                  <label class="margin-bottom-0px font-family text-align-center font-weight-bold">{{THCKZCount}}</label>
                </div>
              </div>
            </div>
            <div class="col-print-3" *ngIf="THNZCount > 0">
              <div class="row margin-left-0px">
                <div class="col-print-9">
                  <label class="margin-bottom-0px font-family font-weight-normal">THNZ:</label>
                </div>
                <div class="col-print-1 border-bot-1px">
                  <label class="margin-bottom-0px font-family text-align-center font-weight-bold">{{THNZCount}}</label>
                </div>
              </div>
            </div>

          </div>
        </div>
        <!--<div class="col-print-12">
          <div class="row margin-left-0px">
            <div class="col-print-6">
              <div class="row margin-left-0px">
                <div class="col-print-4">
                  <label class="margin-bottom-0px font-family font-weight-normal">Frozen Oocytes:</label>
                </div>
                <div class="col-print-2 border-bot-1px">
                  <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
                </div>
              </div>

              </div>
            <div class="col-print-6">
              <div class="row margin-left-0px">
                <div class="col-print-5">
                  <label class="margin-bottom-0px font-family font-weight-normal">Discarded Oocytes:</label>
                </div>
                <div class="col-print-2 border-bot-1px">
                  <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
                </div>
              </div>
            </div>
            </div>
        </div>-->
        <!--<div class="col-print-12">
          <div class="row margin-left-0px margin-right-0px">
            <div class="col-print-6">
              <label class="margin-bottom-0px font-family"></label>
            </div>
            <div class="col-print-6">
              <label class="margin-bottom-0px font-family"></label>
            </div>
          </div>
        </div>-->
        <!--<div class="col-print-12">
          <div class="row margin-left-0px margin-right-0px">
            <div class="col-print-6">
              <label class="margin-bottom-0px font-family"></label>
            </div>
            <div class="col-print-6">
              <label class="margin-bottom-0px font-family"></label>
            </div>
          </div>
        </div>
        <div class="col-print-12">
          <div class="row margin-left-0px margin-right-0px">
            <div class="col-print-7">
              <label class="margin-bottom-0px font-family">Surgeon</label>
            </div>
            <div class="col-print-5 doNotPrint">
              <label class="margin-bottom-0px font-family">Assistant Surgeon</label>
            </div>
          </div>
        </div>-->
        <!--<div class="col-print-12">
          <div class="row margin-left-0px margin-right-0px">
            <div class="col-print-6">
              <label class="margin-bottom-0px font-family"></label>
            </div>
            <div class="col-print-6">
              <label class="margin-bottom-0px font-family"></label>
            </div>
          </div>
        </div>-->
        <!--<div class="col-print-12">
          <div class="row margin-left-0px margin-right-0px">
            <div class="col-print-7">
              <div class="row margin-left-0px margin-right-0px">
                <div class="col-print-4 border-bot-1px">
                  <label class="margin-bottom-0px font-family text-align-center">{{Sign1Name}}</label>
                </div>
                <div class="col-print-6">
                  <label class="margin-bottom-0px font-family"></label>
                </div>
              </div>
            </div>
            <div class="col-print-5 doNotPrint">
              <div class="row margin-left-0px margin-right-0px">
                <div class="col-print-6 border-bot-1px">
                  <label class="margin-bottom-0px font-family text-align-center"></label>
                </div>
                <div class="col-print-5">
                  <label class="margin-bottom-0px font-family"></label>
                </div>
              </div>
            </div>
          </div>
        </div>-->

      </div>
    </div>
  </div>
</div>
<!--<printfooterview></printfooterview>-->

<!--<div class="col-print-11">
  <div class="row margin-right-0px margin-left-0px">
    <div class="col-print-11">
      <div class="table-component margin-bottom-0px border4">
        <div class="table-responsive">
          <table class="table table-striped margin-left-zero">
            <thead>
              <tr>
                <th class="background-primary padding-top-2px padding-bottom-2px width-35px text-align-center">
                  <label class="font-weight-normal margin-bottom-0px font-family">S.No</label>
                </th>

                <th class="background-primary padding-top-2px padding-bottom-2px width-35px text-align-center">
                  <label class="font-weight-normal margin-bottom-0px font-family">Well#</label>
                </th>

                <th class="background-primary text-align-center padding-top-2px padding-bottom-2px width-150px">
                  <label class="font-weight-normal margin-bottom-0px font-family">OCC</label>
                </th>
                <th class="background-primary text-align-center padding-top-2px padding-bottom-2px width-150px">
                  <label class="font-weight-normal margin-bottom-0px font-family">Denuded</label>
                </th>
                <th class="background-primary text-align-center padding-top-2px padding-bottom-2px">
                  <label class="font-weight-normal margin-bottom-0px font-family">Morphology</label>
                </th>
                <th class="background-primary text-align-center padding-top-2px padding-bottom-2px">
                  <label class="font-weight-normal margin-bottom-0px font-family">Status</label>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let l of CurrentOocyteQualityAssessmentByCodeController ; let RowIndex = index ">
                <td class="padding-top-2px padding-bottom-2px text-align-center">
                  <label class="font-weight-normal margin-bottom-0px font-family">{{RowIndex+1}}</label>
                </td>
                <td class="padding-top-2px padding-bottom-2px text-align-center">
                  <label class="font-weight-normal margin-bottom-0px font-family">{{l.WellNo}}</label>
                </td>
                <td class="padding-top-2px padding-bottom-2px text-align-center">
                  <label class="font-weight-normal margin-bottom-0px font-family">{{l.OocyteQualityPre}}</label>
                </td>
                <td class="padding-top-2px padding-bottom-2px text-align-center">
                  <label class="font-weight-normal margin-bottom-0px font-family">{{l.OocyteQualityPost}}</label>
                </td>
                <td class="padding-top-2px padding-bottom-2px text-align-center">
                  <label class="font-weight-normal margin-bottom-0px font-family">{{l.Morphology}}</label>
                </td>
                <td class="padding-top-2px padding-bottom-2px text-align-center">
                  <label class="font-weight-normal margin-bottom-0px font-family">{{l.RecordStatus}}</label>
                </td>
              </tr>
            </tbody>
          </table>

        </div>
      </div>
    </div>
  </div>
</div>-->
